<template>
  <div>
    <main>
      <div class="main_content">
        <div class="about_content">
          <!--          右侧信息栏-->
          <div class="case_r fr">
            <div class="f24">
              {{detailist.name}}
            </div>
            <div class="case_con" v-if="detailist.intro">
              <span> {{detailist.intro}}</span>
            </div>
            <div class="case_infor col_6" v-if="detailist.scene">
              <span>{{detailist.scene}}</span>
            </div>
            <div class="case_infor" v-if="detailist.site">
              <div>
                <p class="fl p1">网址</p>
                <p class="fl col_6"><a class="col_6" :href="detailist.site" target="_Blank" rel="nofollow">{{detailist.site}}</a>
                </p>
              </div>
            </div>

            <div class="case_infor"  v-if="detailist.code_img">
              <div class="code_img">
                <img  :src="detailist.code_img" />
              </div>
            </div>

            <div class="case_click">
              <!--              <router-link to="" tag="a" title="上一篇" class="case_click2" @click.native="caseup"></router-link>-->
              <!--              <router-link to="" tag="a" title="下一篇" class="case_click3" @click.native="casedown"></router-link>-->
              <el-button type="danger" icon="el-icon-arrow-left" circle @click.native="caseup"
                         :disabled="!detailist.caseup"></el-button>
              <el-button type="danger" icon="el-icon-arrow-right" circle @click.native="casedown"
                         :disabled="!detailist.casedown"></el-button>
            </div>
          </div>
          <!--          左侧轮播图-->
          <div class="about_news">
            <div class="wrapper_div">
              <div class="wrapper_news">
                <swiper :options="swiperOption" class="swiper-container" v-if="swiperft">
                  <swiper-slide class="swiper-item" v-for="item of detailist.banner" :key="item.id">
                    <img class="swiper-img" :src="item.url" alt="图片集"/>
                  </swiper-slide>
                </swiper>
                <div class="swiper-paginations" slot="pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        casemenu: '2',
        swiperft: true,
        detailist: {
          id: "",//案例id
          name: "",
          intro: '',
          scene: '',
          site: '',
          caseups: '',
          casedowns: '',
          upId: '',
          downId: '',
          banner: [
            {img: ''},
            {img: ''}
          ]
        },
        swiperOption: {
          pagination: {
            el: ".swiper-paginations",
            clickable: true, // 允许点击小圆点跳转

          },

          autoplay: {
            delay: 2500,
            stopOnLastSlide: false,
            disableOnInteraction: false
          }, //自动播放

          speed: 800, //滑动速度
          setWrapperSize: true,
          observeParents: true,
          paginationClickable: true, //点击分页器的指示点分页器控制Swiper切换
          loop: true, //循环
          observer: true,
          autoplayDisableOnInteraction: true //用户操作swiper之后，是否禁止autoplay
        },
      }
    },
    methods: {
      async getcase(val) {
        this.swiperft = false;
        var open = [this.detailist.caseup,this.detailist.casedown]
        this.detailist.caseup = false
        this.detailist.casedown = false
        if(this.casemenu == '' || this.casemenu == undefined){
          this.casemenu = 2;
          console.log(this.casemenu)
        }
        var dt = await this.$axios.post('/api/details', {
          case: val,
          casemenu:this.casemenu
        })
        dt.data = JSON.parse(dt.data)
        // console.log(dt)
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.detailist = dt.data.data
        this.$router.push({
          name: 'details', params: {
            id: val+'.html'
          }
        })
        console.log(open)
        // this.detailist.caseup = open[0]
        // this.detailist.casedown = open[1]
        this.swiperft = true
      },
      caseup() {
        this.getcase(this.detailist.upId)
      },
      casedown() {
        this.getcase(this.detailist.downId)
      },
    },
    created() {
      this.detailist.id = this.$route.params.id.split('.')[0];
      this.casemenu = this.$route.params.casemenu;
      this.getcase(this.detailist.id)
    },
    watch: {
      $route(to, from) {
        this.getcase(this.$route.params.id.split('.')[0])
      }
    }

  }
</script>

<style lang="less" scoped>
  .el-button--danger:focus, .el-button--danger:hover{
    background: #f56c6c;
    border-color: #f56c6c;
    color: #fff;
  }
  @deep: ~'>>>';
  main {
    background: #f1f1f1;
  }

  /* 轮播按钮 */
  .swiper-prev {
    background-image: url(http://www.szmynet.com/OA/Public/Home/images/case_clickimg.png);
    background-position: -64px 0;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    position: absolute;
    left: 0;
    z-index: 9999;
    top: 50%;
    margin-top: -27px;
    outline: none;
    opacity: .5;
  }

  .swiper-next {
    background-image: url(http://www.szmynet.com/OA/Public/Home/images/case_clickimg.png);
    background-position: -129px 0;
    outline: none;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    position: absolute;
    right: 0;
    z-index: 9999;
    top: 50%;
    margin-top: -27px;
    opacity: .5;
  }

  .main_content {
    overflow: hidden;
  }


  /* 文章内容 */
  .about_content {
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;

    .about_t {
      font-size: 35px;
      color: #323232;
      text-align: left;
      font-weight: normal;
      margin-top: 30px;
      position: relative;
      /* padding-bottom: 40px; */

      padding-bottom: 15px;
    }

    .about_t:after {
      content: "";
      display: block;
      width: 70px;
      height: 4px;
      background: #e50012;
      position: absolute;
      left: 0;
      margin: 12px 0 20px 0;
    }

    .about_new {
      color: #6d7276;
      font-size: 16px;
      line-height: 28px;
      margin-bottom: 24px;
    }

    .about_news {
      background: #f2f2f2;
      width: 950px;
      margin: 50px 0;
      text-align: center;

      img {
        width: 100%;
        margin: 10px auto;
        display: block
      }
    }


    /* 头部例3*/

    .case_r {
      min-height: 440px;
      box-shadow: 1px 1px 8px -1px #999;
      position: absolute;
      right: 10px;
      border-radius: 5px;
      width: 400px;
      padding: 50px 40px;
      background: #fff;
      z-index: 99;

      .case_con {
        color: #666;
        font-size: 16px;
        line-height: 30px;
        padding-bottom: 16px;
        padding-top: 12px;
        border-bottom: 1px dotted #d9d9d9;
        overflow: hidden;
        span{
          overflow: hidden;
        /*-webkit-line-clamp: 2;*/
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        }
      }

      .case_infor {
        font-size: 16px;
        line-height: 30px;
        padding: 14px 0;
        border-bottom: 1px dotted #d9d9d9;
        overflow: hidden;

        span{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .code_img{
          width: 100px;
          img{
            width: 100%;
          }
        }

        div {
          overflow: hidden;

          .p1 {
            padding-right: 10px;
          }
        }
      }

      .case_click {
        padding: 50px 0 0;
        display: flex;
        justify-content: center;
        align-content: center;
        position: absolute;
        bottom: 55px;
        width: 400px;

        a {
          display: inline-block;
          float: left;
          width: 48px;
          height: 48px;
          margin: 0 15px;
        }

        .case_click2 {
          background-image: url(../../assets/images/for_l.png);
        }

        .case_click3 {
          background-image: url(../../assets/images/for_r.png);
        }

      }
    }

  }

  /* 底部翻页 */
  .content_footer {
    overflow: hidden;
    border-top: 1px dotted #999;
    margin-top: 30px;
    margin: 0 4% 10px;
    padding: 10px 0;
    color: #999;

  }

  /* 内容页图片滑动 */
  .wrapper_div {
    position: relative;
    border-radius: 5px;
    background: rgba(250,250,250);
    padding: 15px;
    margin: auto;
    box-shadow: 0 2px 15px 0 #c9c9c9;
    min-height: 630px;
  }

  .swiper-slide {
    max-height: 600px;
    overflow: hidden;
  }


  .swiper-paginations {
    position: absolute;
    bottom: -30px;
    width: 100%;
  }

  @{deep}.swiper-pagination-bullet {
    outline: none;
    width: 40px !important;
    height: 8px !important;
    background: red !important;
    margin: 0 5px !important;
    opacity: 0.3 !important;
    cursor: pointer !important;
    border-radius: 0px !important;

  }

  @{deep}.swiper-pagination-bullet-active {
    background: red !important;
    opacity: 1 !important;
  }

  @{deep}.el-icon-arrow-left, @{deep}.el-icon-arrow-right {
    font-size: 24px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/details.vue